/**
 * External store for idle countdown ms so the idle timer can update without
 * re-rendering the entire provider tree (route shell, etc.). Subscribers use
 * useSyncExternalStore via useSessionIdleCountdown().
 */

let remainingMs: number | null = null
const listeners = new Set<() => void>()

function emit(): void {
  for (const l of listeners) {
    l()
  }
}

export function getSessionIdleRemainingSnapshot(): number | null {
  return remainingMs
}

export function subscribeSessionIdleRemaining(
  onStoreChange: () => void
): () => void {
  listeners.add(onStoreChange)
  return () => {
    listeners.delete(onStoreChange)
  }
}

export function setSessionIdleRemainingMs(ms: number | null): void {
  if (remainingMs === ms) return
  remainingMs = ms
  emit()
}
